// NACRE Wave 3.2.1 — Buffer shim injected into the vault browser bundle.
// esbuild's `inject` option pulls these symbols into every file that
// references `Buffer`, polyfilling Node's Buffer with the npm `buffer`
// package's browser implementation.
import { Buffer } from 'buffer';
export { Buffer };
